
import { Color, FrontSide, AdditiveBlending } from 'three'

const GlowShaderMaterial = (camera, color) => ({
  uniforms: { 
    c: { type: "f", value: 0.9 },
    p: { type: "f", value: 2.0 },
    glowColor: { type: "c", value: new Color(color) },
    viewVector: { type: "v3", value: camera.position }
  },
  vertexShader: `
    uniform vec3 viewVector;
    uniform float c;
    uniform float p;
    varying float intensity;
    void main() 
    {
        vec3 vNormal = normalize( normalMatrix * normal );
      vec3 vNormel = normalize( normalMatrix * viewVector );
      intensity = pow( c - dot(vNormal, vNormel), p );
      
        gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
    }
  `,
  fragmentShader: `
    uniform vec3 glowColor;
    varying float intensity;
    void main() 
    {
      vec3 glow = glowColor * intensity;
        gl_FragColor = vec4( glow, 1.0 );
    }
  `,
  side: FrontSide,
  blending: AdditiveBlending,
  transparent: true
})

export default GlowShaderMaterial
